import axios from './axios'

export const createTimesheetPosting = ({ data }) => axios.post('timesheet_postings', data)
export const deleteTimesheetPosting = ({ id }) => axios.delete(`timesheet_postings/${id}`)
export const findTimesheetPosting = ({ params, id } = {}) => axios.get(`timesheet_postings/${id}`, { params })
export const getTimesheetPostings = ({ params } = {}) => axios.get('timesheet_postings', { params })
export const updateTimesheetPosting = ({ id, data }) => axios.put(`timesheet_postings/${id}`, data)
